import { render, staticRenderFns } from "./audience.screens.vue?vue&type=template&id=3f90e27c&lang=pug"
import script from "./audience.screens.vue?vue&type=script&lang=js"
export * from "./audience.screens.vue?vue&type=script&lang=js"
import style0 from "./audience.screens.vue?vue&type=style&index=0&id=3f90e27c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports